import { twMerge } from 'tailwind-merge'
import { HTMLAttributes } from 'react'

export const Skeleton = ({
	className,
	...props
}: HTMLAttributes<HTMLDivElement>) => {
	return (
		<div
			className={twMerge('animate-pulse rounded-md bg-gray-300', className)}
			{...props}
		/>
	)
}
